<template>
    <div>
        <!-- 保單借款 -->
        <Layout
            :header="{ text: '申請內容', backBtn: { visible: true }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_HOME } }, }">
            <h2 class="pb-8 text-2xl font-bold">
                申請明細
            </h2>

            <div class="pb-6">
                <h3 class="pb-4 text-xl font-bold">
                    匯款帳號
                </h3>
                <CaseBox :caseBox="accountInfo"></CaseBox>
            </div>

            <div>
                <h3 class="pb-4 text-xl font-bold">
                    借款明細
                </h3>
                <CaseBox :caseBox="moneyInfo"></CaseBox>
                <CaseBox :caseBox="caseBox" :key="i" v-for="(caseBox, i) in caseItemList"></CaseBox>
            </div>

            <div v-if="changedContact.boxList.length > 0" class="pb-2">
                <CaseBox :caseBox="changedContact" />
            </div>

            <div class="pb-2">
                <CaseBox :caseBox="endoresmentContent" />
            </div>

            <div v-if="canCancel" class="text-center">
                <button class="py-3 text-[#EB4751] text-sm" @click="(e) => { infoBoxVisble = true }">取消預約申請
                </button>
            </div>
            <Loading :is-loading="isLoading" />
        </Layout>

        <InfoBox v-show="infoBoxVisble" :closeHandel="() => { infoBoxVisble = false; }" title="確定要取消預約申請嗎？"
            type="confirm" :okHandel="okHandel" :buttonText="{ no: '保留預約', yes: '取消預約' }" />
    </div>
</template>

<script setup>
import '@/assets/cloudCounter/css/style.css';
import { onMounted, ref } from 'vue';
import Layout from '@/components/cloudCounter/Layout.vue';
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import InfoBox from '@/components/cloudCounter/InfoBox.vue';
import { useRoute } from 'vue-router';
import routeName from '@/router/constant';
import { postCancelTransaction, postCecRecord } from '@/apis/record';
import { openPopup, openPopupCatchMessage } from '@/utils/vfmUtils';
import Loading from '@/components/Loading.vue';

const route = useRoute();
const regiNo = ref(route.query?.regiNo);
const isLoading = ref(true);
const accountInfo = ref(null);
const moneyInfo = ref(null);
const caseItemList = ref(null);
const canCancel = ref(false);
const endoresmentContent = ref({
    boxList: [{
        title: '本次變更批註寄送方式',
        list: [{
            key: '',
            value: '',
        }],
    }],
});
const changedContact = ref({
    boxList: []
})

// 串接...
moneyInfo.value = {
    key: '共欲借款總金額',
    value: '',
    flexClass: 'justify-between',
};
caseItemList.value = [];

const infoBoxVisble = ref(false);
const okHandel = () => {
    isLoading.value = true;
    postCancelTransaction(regiNo.value).then(res => {
        openPopup('已完成取消預約申請');
        canCancel.value = false;
    }).catch(ex => {
        openPopupCatchMessage(ex);
    }).finally(() => {
        isLoading.value = false;
    });
};

const thousandthsFormat = (value) => {
    const regex = /\B(?=(\d{3})+(?!\d))/g
    value = value.toString()
    return value.replace(regex, ',')
}

onMounted(() => {
    postCecRecord(regiNo.value).then(res => {
        const a = res.data.pon4300.after;
        accountInfo.value = {
            key: '銀行帳號',
            value: `${a.bank.bankNo} ${a.bank.bankName} <br>${a.bank.bankAccount}`,
        };
        moneyInfo.value = {
            key: '共欲借款總金額',
            value: `$${thousandthsFormat(a?.totalAmount)}`,
            flexClass: 'justify-between',
        };
        a.pon4300ResultDataList.forEach(p => {
            caseItemList.value.push({
                boxList: [
                    {
                        title: `${p.item} ${p.itemName}`,
                        subTitle: `${p.fullPolicyNo}`,
                        iconTitle: '',
                        flexClass: '',
                        list: [
                            {
                                key: '本月利率（年利率）',
                                value: `${p.loanRate}%`,
                            },
                            {
                                key: '借款幣別',
                                value: `${a.currencyText}`,
                            },
                            {
                                key: '借款金額',
                                value: `$${thousandthsFormat(p.amount)}`,
                            },
                        ],
                    },
                ],
            });
        });
        canCancel.value = res.data.canCancel;
        endoresmentContent.value.boxList[0].list[0].value = res.data?.endorsementDesc;
        if (res.data.pon4300?.insMobile) {
            changedContact.value.boxList.push({
                title: '要保人行動電話',
                list: [{
                    key: '行動電話',
                    value: res.data.pon4300?.insMobile?.mobile
                }]
            })
        }
        if (res.data.pon4300?.insuredMobile) {
            changedContact.value.boxList.push({
                title: '被保險人行動電話',
                list: [{
                    key: '行動電話',
                    value: res.data.pon4300?.insuredMobile?.mobile
                }]
            })
        }
    }).catch(ex => {
        console.log(ex);
        openPopupCatchMessage(ex);
    }).finally(() => {
        isLoading.value = false;
    });
});
</script>

<style scoped></style>
